import { FC } from 'react';
import cn from 'classnames';

import { IStatusDotProps, TStatusDotIcon } from './StatusDot.interface';

import './style.scss';

const StatusDot: FC<IStatusDotProps> = ({ className, icon, title, small }) => (
  <div
    className={cn(
      'status-dot',
      {
        'status-dot_blank': icon === TStatusDotIcon.Blank,
        'status-dot_red': icon === TStatusDotIcon.Red,
        'status-dot_blue': icon === TStatusDotIcon.Blue,
        'status-dot_orange': icon === TStatusDotIcon.Orange,
        'status-dot_yellow': icon === TStatusDotIcon.Yellow,
        'status-dot_green': icon === TStatusDotIcon.Green,
        'status-dot_small': small,
      },
      className,
    )}
    title={title}
  />
);

export default StatusDot;
